// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ces-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 48px 20px;
  text-align: center;
}

.ces-compact {
  padding: 24px 14px;
}

.ces-icon {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  border-radius: 50%;
  background: var(--cui-primary-soft);
  color: var(--cui-primary);
}

.ces-compact .ces-icon {
  width: 44px;
  height: 44px;
  margin-bottom: 10px;
}

.ces-error .ces-icon {
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
}

.ces-title {
  color: var(--cui-text);
  font-size: 15px;
  font-weight: 700;
}

.ces-compact .ces-title {
  font-size: 14px;
}

.ces-desc {
  max-width: 380px;
  margin-top: 6px;
  color: var(--cui-text-muted);
  font-size: var(--cui-font-size);
  line-height: 1.5;
}

.ces-action {
  margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomEmptyState/CustomEmptyState.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".ces-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 48px 20px;\n  text-align: center;\n}\n\n.ces-compact {\n  padding: 24px 14px;\n}\n\n.ces-icon {\n  display: grid;\n  place-items: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 14px;\n  border-radius: 50%;\n  background: var(--cui-primary-soft);\n  color: var(--cui-primary);\n}\n\n.ces-compact .ces-icon {\n  width: 44px;\n  height: 44px;\n  margin-bottom: 10px;\n}\n\n.ces-error .ces-icon {\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n}\n\n.ces-title {\n  color: var(--cui-text);\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.ces-compact .ces-title {\n  font-size: 14px;\n}\n\n.ces-desc {\n  max-width: 380px;\n  margin-top: 6px;\n  color: var(--cui-text-muted);\n  font-size: var(--cui-font-size);\n  line-height: 1.5;\n}\n\n.ces-action {\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
